import { Button, CircularProgress } from "@mui/material";
import Flex from "../../../../../components/Flex";
import useCurrentUser from "../../../../../hooks/local-storage/use-current-user";
import { ChatUser } from "../messages/ChatUser";

interface ChatSideBarProps {
  selectedUser: any;
  onCurrentUserChange: (user: any) => void;
  searchKey?: string;
  convoList?: any;
  isLoading?: boolean;
}

export const ChatSideBar = ({
  selectedUser,
  onCurrentUserChange,
  // todo: need to add search key for the query
  searchKey: _,
  convoList,
  isLoading = false,
}: ChatSideBarProps) => {
  const [me] = useCurrentUser();

  return (
    <Flex
      height={"calc(100svh - 13rem)"}
      flexDirection={"column"}
      gap={1}
      width={"28.35rem"}
      overflow={"scroll"}
    >
      {isLoading && (
        <Flex width={"100%"} justifyContent={"center"}>
          <CircularProgress />
        </Flex>
      )}

      {/* TODO: need to  change type any to actual type*/}
      {convoList?.map((user: any) => {
        const isSelectedUser = selectedUser?.uuid === user.uuid;

        // check from where the convo created
        const name =
          user?.participant2 === me?.uuid
            ? user?.senderName
            : user?.receiverName;

        return (
          <Button
            key={user.uuid}
            fullWidth
            sx={{
              width: "100%",
              height: "auto",
              transition: "background-color 0.3s ease-in",
              backgroundColor: isSelectedUser ? "#EEF7FF" : "transparent",
              boxShadow: "none",
              "&:hover": {
                backgroundColor: isSelectedUser
                  ? "#EEF7FF"
                  : "rgba(0, 0, 0, 0.04)",
                boxShadow: "none",
              },
              "&:active": {
                backgroundColor: isSelectedUser
                  ? "#EEF7FF"
                  : "rgba(0, 0, 0, 0.08)",
                boxShadow: "none",
              },
            }}
            variant="text"
            onClick={() => onCurrentUserChange(user)}
          >
            <Flex width={"inherit"} height={"3.5rem"} alignItems={"center"}>
              <ChatUser
                dob={user?.patientDob}
                gender={user?.patientGender}
                name={name}
                message={isSelectedUser ? undefined : user?.lastSms}
                lastOnline={isSelectedUser ? undefined : user?.lastSmsTime}
                recentUnreadMsg={
                  isSelectedUser ? undefined : user?.unReadSmsCount
                }
              />
            </Flex>
          </Button>
        );
      })}
    </Flex>
  );
};
